import { ModalComponent } from '../../../../config/core.modal-helpers';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { ProjectService } from '../../../../services/project.service';
import { UiService } from '../../../../services/core.ui.service';
import { GfTranslateService } from '../../../../services/core.translate.service';
import { ProjectSprintData } from '../../services/project.sprint.data.service';

import * as _ from 'lodash';

@Component({
    selector: 'project-sprint-cutover',
    template: require('./project.sprint.cutover.html'),
})
export class ProjectSprintCutoverComponent extends ModalComponent implements OnInit, OnChanges {

    @Input() sprint: any = null;
    @Input() project: any = null;

    @Input() legacyCallback: any = null;

    @Output() callback = new EventEmitter<any>();

    // Sprint Cut-over
    protected moveTickets = {
        option: false,
        nextSprint: null,
        sprints: []
    };

    constructor(
        private projectService: ProjectService,
        private uiService: UiService,
        private gfTranslateService: GfTranslateService,
        private projectSprintData: ProjectSprintData,
    ) {
        super();
    }
    ngOnInit(): void {
        if (this.sprint) {
            this.setupSprintCutover(this.sprint);
        }
        // this.getTitle = ProjectSprintData.getSprintTitle;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.sprint && !changes.sprint.isFirstChange()) {
            this.setupSprintCutover(changes.sprint.currentValue);
        }
    }

    getTitle(sprint) {
        return this.projectSprintData.getSprintTitle(sprint);
    }

    processSprintCutover() {
        var updateSprintObject = {
            id: this.sprint.id,
            project: this.project.id,
            sprintStatus: 2,
            destinationId: null
        };

        if(_.get(this.moveTickets, 'option', false))
            updateSprintObject.destinationId = this.moveTickets?.nextSprint?.id ?? null;

        var ret = false;

        this.projectService.updateSprint(updateSprintObject)        
        .then(() => {
            ret = true;
            this.uiService.message.showSuccess(this.gfTranslateService.translate('This sprint TI have been succesfuly moved.'), 'Sprint cutover');
        })
        .catch(() => {
            var msg =  this.gfTranslateService.translate('There was a problem moving the sprint TI');
            this.uiService.message.showWarning(msg, 'Data Error');
        })
        .finally(() => {
            this.legacyCallback && this.legacyCallback(this.sprint, ret);
            this.callback.emit(this.sprint);
            this.closeModal(ret);
        });;
    };


    setupSprintCutover(sprint) {
        var params = {
            page_size: 20,
            page_num: 1,
            sort_field: 'id',
            sort_dir: 'asc',
            sprint_status: 0
        };

        this.projectService.sprints(this.project.unixName, params)
        .then((response) => {
            var sprints = _.filter(
                _.get(response, 'items', []),
                (candidate) => {
                    return (candidate.id > sprint.id);
                }
            );

            this.moveTickets = {
                option: (sprints.length > 0),
                nextSprint: _.get(sprints, '[0]', null),
                sprints: sprints
            };
        })
        .catch(() => {
            this.uiService.message.showWarning(
                this.gfTranslateService.translate("Sorry, could not get the list of sprints for cut-over."),
                this.gfTranslateService.translate("Data Error")
            );

            this.moveTickets = {
                option: false,
                nextSprint: null,
                sprints: []
            };
        });
    }

}